// extracted by mini-css-extract-plugin
export default {"container":"R0iWYV","noMargin":"fRtwxj","left":"oUZmci","wrapper":"wUsbqX","titleWrapper":"YBtyIU","title":"CD_TVO","descriptionWrapper":"LDnrup","description":"RvqllM"};